exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter {\n    opacity: 0.01;\n}\n\n.fade-enter.fade-enter-active {\n    opacity: 1;\n    transition: opacity 300ms ease-in;\n}\n\n.fade-leave {\n    opacity: 1;\n}\n\n.fade-leave.fade-leave-active {\n    opacity: 0.01;\n    transition: opacity 300ms ease-in;\n}\n\n.TimePicker {\n    font-size: 3em;\n}\n\n.pre-test-container {\n    padding-top: 10px;\n    margin-left: 1em;\n    margin-right: 1em;\n}", ""]);

// exports
